<div class="menu-backdrop"></div>

@if (nvdbNavigation.isMobileDevice) {
    <div class="mobile-menu" #mobileMenu [style.height]="menuHeight">
        <ng-container *ngTemplateOutlet="menu_content"></ng-container>
    </div>
} @else if (nvdbNavigation.sideBarVisible && !nvdbNavigation.hideHamburgerMenu && !trvMapService.trvMap?.showStreetView) {
    <div class="sidebar-sticky sidebar-full" [style.width.px]="nvdbNavigation.sideBarWidth" @trvCollapseVoidAnimation #sidebar>
        <ng-container *ngTemplateOutlet="menu_content"></ng-container>
        <div class="resize_handle" #resizeHandle (mousedown)="onMouseDown($event)"></div>
    </div>
}

<ng-template #menu_content>
    @if (!nvdbNavigation.isMobileDevice) {
        <div class="menu_header has-back-nav">
            <div class="menu_header__title">
                {{ nvdbNavigation.siteTitle }}
            </div>

            <div class="menu_header__handle left">
                <button class="btn btn-link" (click)="menuToggle()" aria-label="Stäng meny">
                    <app-svg-icon [svgIcon]="crossIcon"></app-svg-icon>
                </button>
            </div>
        </div>
    }

    <div class="menu-tab" [ngClass]="{ 'menu-tab-mobile': nvdbNavigation.isMobileDevice, 'mobile-fullscreen': menuAlmostFullHeight }">
        <div [ngClass]="{ draggable_pill: nvdbNavigation.isMobileDevice && !menuAlmostFullHeight }"></div>
        <div
            (click)="nvdbNavigation.currentMobileMenuState.setValue('Medium')"
            [ngClass]="nvdbNavigation.isMobileDevice && menuAlmostFullHeight ? 'show_arrow' : 'hide_arrow'"
        >
            <fa-icon [icon]="faAngleDown"></fa-icon>
        </div>
        <div class="item-parent" [ngClass]="{ 'item-parent-mobile': nvdbNavigation.isMobileDevice }">
            <div
                class="item"
                (click)="changeNavigationState(NavigationState.MainMenu)"
                [ngClass]="{
                    active: nvdbNavigation.navigationState == NavigationState.MainMenu,
                }"
            >
                @if (!nvdbNavigation.isMobileDevice) {
                    Start
                } @else {
                    <fa-icon [icon]="faHouse" trvTooltip="Start" [position]="['top', 'right']"></fa-icon>
                }
                <div class="underline"></div>
            </div>

            <div
                class="item"
                (click)="changeNavigationState(NavigationState.InfoClick)"
                [ngClass]="{
                    active: nvdbNavigation.navigationState == NavigationState.InfoClick,
                }"
            >
                @if (!nvdbNavigation.isMobileDevice) {
                    {{ lang.GetValue('InfoClick.InfoClick') }}
                } @else {
                    <fa-icon [icon]="faInfoCircle" trvTooltip="Infoklick" [position]="['top']"></fa-icon>
                }
                <div class="underline"></div>
            </div>
            <div
                class="item"
                (click)="changeNavigationState(NavigationState.PrintMap)"
                [ngClass]="{
                    active: nvdbNavigation.navigationState == NavigationState.PrintMap,
                }"
            >
                @if (!nvdbNavigation.isMobileDevice) {
                     {{ lang.GetValue('PrintMenu.Print') }}
                } @else {
                    <fa-icon [icon]="faPrint" trvTooltip="Utskrift" [position]="['top']"></fa-icon>
                }
                <div class="underline"></div>
            </div>

            @if (nvdbNavigation.isMobileDevice) {
                <div
                    class="item"
                    (click)="changeNavigationState(NavigationState.TeckenForklaring)"
                    [ngClass]="{
                        active: nvdbNavigation.navigationState == NavigationState.TeckenForklaring,
                    }"
                >
                    @if (!nvdbNavigation.isMobileDevice) {
                        Teckenförklaring
                    } @else {
                        <fa-icon [icon]="faTag" trvTooltip="Teckenförklaring" [position]="['top', 'left']"></fa-icon>
                    }
                    <div class="underline"></div>
                </div>
            }
        </div>
    </div>
    @if (nvdbNavigation.navigationState == NavigationState.MainMenu) {
        @if (nvdbNavigation.isMobileDevice) {
            <div class="mobile-menu-items">
                <div (click)="toggleSearch(true)" class="mobile-menu-item" [ngClass]="{ active: nvdbNavigation.startMenuState.showSearchSection }">
                    <app-svg-icon trvTooltip="Sök" [position]="['top', 'left', 'right']" [svgIcon]="searchIcon"></app-svg-icon>
                </div>
                <div
                    (click)="toggleDataslag(true)"
                    class="mobile-menu-item"
                    [ngClass]="{ active: nvdbNavigation.startMenuState.showDataslagSection }"
                >
                    <app-svg-icon trvTooltip="Dataprodukter" [position]="['top', 'left', 'right']" [svgIcon]="pinIcon"></app-svg-icon>
                </div>
                <div (click)="toggleLager(true)" class="mobile-menu-item" [ngClass]="{ active: nvdbNavigation.startMenuState.showLagerSection }">
                    <app-svg-icon trvTooltip="Lager" [position]="['top', 'left', 'right']" [svgIcon]="layerIcon"></app-svg-icon>
                </div>
                <div (click)="toggleVyer(true)" class="mobile-menu-item" [ngClass]="{ active: nvdbNavigation.startMenuState.showVyerSection }">
                    <app-svg-icon trvTooltip="Sparade vyer" [position]="['top', 'left', 'right']" [svgIcon]="starIcon"></app-svg-icon>
                </div>
                <div
                    (click)="toggleShareMap(true)"
                    class="mobile-menu-item"
                    [ngClass]="{ active: nvdbNavigation.startMenuState.showShareMapSection }"
                >
                    <app-svg-icon trvTooltip="Dela karta" [position]="['top', 'left', 'right']" [svgIcon]="svgShareLink"></app-svg-icon>
                </div>
            </div>

            <div class="mobile-menu--content mobile">
                @if (nvdbNavigation.startMenuState.showSearchSection) {
                    <div class="menu-item-content mobile">
                        <app-search-section></app-search-section>
                    </div>
                }

                @if (nvdbNavigation.startMenuState.showDataslagSection) {
                    <div class="menu-item-content mobile">
                        <app-dataslag-section></app-dataslag-section>
                    </div>
                }
                @if (environment.application == 'NjdbPåWebb') {
                } @else {}
                @if (nvdbNavigation.startMenuState.showLagerSection) {
                    <div class="menu-item-content mobile">
                        <app-layer-section></app-layer-section>
                    </div>
                }

                @if (nvdbNavigation.startMenuState.showVyerSection) {
                    <div class="menu-item-content mobile">
                        <app-saved-view-section></app-saved-view-section>
                    </div>
                }

                @if (nvdbNavigation.startMenuState.showShareMapSection) {
                    <div class="menu-item-content mobile">
                        <app-share-map-section></app-share-map-section>
                    </div>
                }
            </div>
        } @else {
            <div class="mobile-menu--content">
                <app-map-menu-item
                    [leftIcon]="searchIcon"
                    [itemName]="lang.GetValue('Searchmenu.Search')"
                    [open]="nvdbNavigation.startMenuState.showSearchSection"
                    (click)="toggleSearch()"
                ></app-map-menu-item>
                @if (nvdbNavigation.startMenuState.showSearchSection) {
                    <div class="menu-item-content" @trvCollapseVoidAnimation>
                        <app-search-section></app-search-section>
                    </div>
                }
                @if (environment.application == "NjdbPåWebb") {
                <app-map-menu-item
                    [leftIcon]="pinIcon"
                    [itemName]="'Dataprodukter'"
                    Layerlist.DataProducts
                    [open]="nvdbNavigation.startMenuState.showDataslagSection"
                    (click)="toggleDataslag()"
                ></app-map-menu-item>
                }

                @else if (environment.application == "JNBKarta") {
                    <app-map-menu-item
                        [leftIcon]="pinIcon"
                        [itemName]="lang.GetValue('Layerlist.DataProducts')"
                        [open]="nvdbNavigation.startMenuState.showDataslagSection"
                        (click)="toggleDataslag()"
                    ></app-map-menu-item>
                    }

                @if (nvdbNavigation.startMenuState.showDataslagSection) {
                    <div class="menu-item-content" @trvCollapseVoidAnimation>
                        <app-dataslag-section></app-dataslag-section>
                    </div>
                }
               
                    <app-map-menu-item
                        [leftIcon]="layerIcon"
                        [itemName]="lang.GetValue('BackgroundList.Layer')"
                        [open]="nvdbNavigation.startMenuState.showLagerSection"
                        (click)="toggleLager()"
                    ></app-map-menu-item>
           
                @if (nvdbNavigation.startMenuState.showLagerSection) {
                    <div class="menu-item-content" @trvCollapseVoidAnimation>
                        <app-layer-section></app-layer-section>
                    </div>
                }

                <app-map-menu-item
                    [leftIcon]="starIcon"
                    [itemName]="lang.GetValue('SavedViews.SavedViews')"
                    [open]="nvdbNavigation.startMenuState.showVyerSection"
                    (click)="toggleVyer()"
                ></app-map-menu-item>

                @if (nvdbNavigation.startMenuState.showVyerSection) {
                    <div class="menu-item-content" @trvCollapseVoidAnimation>
                        <app-saved-view-section></app-saved-view-section>
                    </div>
                }

                <app-map-menu-item
                    [leftIcon]="svgShareLink"
                    [itemName]="lang.GetValue('ShareMap.ShareMap')"
                    [open]="nvdbNavigation.startMenuState.showShareMapSection"
                    (click)="toggleShareMap()"
                ></app-map-menu-item>

                @if (nvdbNavigation.startMenuState.showShareMapSection) {
                    <div class="menu-item-content" @trvCollapseVoidAnimation>
                        <app-share-map-section></app-share-map-section>
                    </div>
                }
            </div>
        }
    }
    @if (nvdbNavigation.navigationState == NavigationState.InfoClick) {
        <div class="mobile-menu--content">
            <app-info-click-tab></app-info-click-tab>
        </div>
    } @else if (nvdbNavigation.navigationState == NavigationState.PrintMap) {
        <div class="mobile-menu--content">
            <div>
                <app-print-map-tab></app-print-map-tab>
            </div>
        </div>
    } @else if (nvdbNavigation.navigationState == NavigationState.TeckenForklaring) {
        <div class="mobile-menu--content" style="background: white; height: 100%">
            <div>
                <app-tecken-forklaring-tab></app-tecken-forklaring-tab>
            </div>
        </div>
    }
</ng-template>
